import {InterativoGestor, LIMITE_ROTULO, MensagemGestor} from './conversa-gestor.store';

/** ligada por `?vitrine=1` na URL — só para conferir estilo, nunca em uso real */
export function modoVitrine(): boolean {
  return typeof window !== 'undefined' && /[?&]vitrine=1\b/.test(window.location.search);
}

function botoes(rotulos: string[]): InterativoGestor {
  return {
    tipo: 'botoes',
    botoes: rotulos.slice(0, 3).map(rotulo => ({rotulo: rotulo.slice(0, LIMITE_ROTULO), acao: 'texto' as const})),
  };
}

function lista(rotulo: string, itens: Array<{titulo: string; descricao: string}>): InterativoGestor {
  return {tipo: 'lista', rotulo: rotulo.slice(0, LIMITE_ROTULO), itens};
}

function link(rotulo: string, url: string): InterativoGestor {
  return {tipo: 'link', botoes: [{rotulo: rotulo.slice(0, LIMITE_ROTULO), acao: 'abrir' as const, href: url}]};
}

/**
 * Conversa de mentira para conferir o estilo das telas do Gestor sem falar com
 * o agente: cobre todo tipo de bolha que o canal sabe renderizar (texto,
 * botões, lista, cta_url), mais nota de sistema e anexo.
 *
 * Serve só para olhar a tela — não chama rede, não cria empresa, não guarda
 * nada. Ligada por `?vitrine=1` na URL do painel ou do simulador.
 */
export function mensagensDeVitrine(): MensagemGestor[] {
  const agora = Date.now();
  const em = (minutos: number) => new Date(agora - minutos * 60000);

  return [
    {
      papel: 'gestor',
      horario: em(14),
      texto: 'Oi! Eu sou a Mia. Em alguns minutos a gente deixa sua loja no ar.\n\nPra começar, me diga o *nome do seu negócio*.',
    },
    {papel: 'usuario', horario: em(13), texto: 'Cantinho do Sabor'},
    {
      papel: 'gestor',
      horario: em(13),
      texto: 'Anotei: *Cantinho do Sabor*. Você atende de que forma?',
      interativo: botoes(['Entrega e retirada', 'Só retirada', 'Só entrega']),
      ferramentas: [{nome: 'salvar_empresa', sucesso: true, duracaoMs: 412}],
    },
    {papel: 'usuario', horario: em(12), texto: 'Entrega e retirada'},
    {papel: 'nota', horario: em(12), texto: 'Empresa criada com o nome Cantinho do Sabor.'},
    {
      papel: 'gestor',
      horario: em(11),
      texto: 'Agora o cardápio. Pode mandar uma foto, um PDF ou digitar os itens — o que for mais rápido pra você.',
      interativo: lista('Como enviar', [
        {titulo: 'Mandar foto', descricao: 'Foto do cardápio impresso ou do quadro'},
        {titulo: 'Mandar PDF', descricao: 'Arquivo que você já usa hoje'},
        {titulo: 'Digitar aqui', descricao: 'Escrever os itens na conversa'},
      ]),
    },
    {
      papel: 'usuario',
      horario: em(9),
      texto: '',
      documento: {nome: 'cardapio-atual.pdf', tamanhoBytes: 843012, quantidade: 1},
    },
    {
      papel: 'gestor',
      horario: em(8),
      texto: 'Li 4 categorias e 32 itens. *6 itens ficaram sem preço* — eu marquei pra você revisar antes de publicar.',
      ferramentas: [
        {nome: 'analisar_cardapio', sucesso: true, duracaoMs: 18240},
        {nome: 'montar_rascunho', sucesso: true, duracaoMs: 233},
      ],
    },
    {papel: 'usuario', horario: em(6), texto: 'Pode publicar do jeito que está, eu ajusto o preço depois'},
    {
      papel: 'gestor',
      horario: em(5),
      texto: 'Publiquei. Sua loja já está no ar neste endereço:\nmeucardapio.ai/cantinho-do-sabor',
      interativo: link('Abrir minha loja', 'https://meucardapio.ai/cantinho-do-sabor'),
    },
    {
      papel: 'gestor',
      horario: em(4),
      texto: 'Falta só definir o *bairro* que você atende e o valor da entrega. Quer fazer isso agora?',
      interativo: botoes(['Quero definir agora', 'Deixa pra depois']),
    },
  ];
}
